import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input } from '@angular/core';
import { GoogleLookupSelection } from './google-lookup-selection.model';
// import { } from '@types/googlemaps';
declare const google: any;


@Component({
  selector: 'app-autocomplete-component',
  templateUrl: './autocomplete-component.component.html',
  styleUrls: ['./autocomplete-component.component.css']
})
export class AutocompleteComponentComponent implements OnInit, AfterViewInit {

  @Input() adressType: string;
  @Output() setAddress: EventEmitter<GoogleLookupSelection> = new EventEmitter();
  @ViewChild('addresstext') addresstext: any;

  autocompleteInput: string;
  queryWait: boolean;


  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
}


private getPlaceAutocomplete() {
  const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
      {
          componentRestrictions: { country: 'AU' },
          types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
      });
  google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
  });
}

invokeEvent(place: any) {
  const inputValue = this.addresstext && this.addresstext.nativeElement
    ? this.addresstext.nativeElement.value
    : this.autocompleteInput;
  const lookupText = (inputValue || (place && place.formatted_address) || '').trim();

  this.autocompleteInput = lookupText;
  this.setAddress.emit({ place: place, lookupText: lookupText });
}




}
